import { Modals } from '@funnels/ui-components';

import { Text, Title } from './index.style';

export const NOT_ALLOW_BEFORE_TIME = new Date('2020-05-01').getTime();
export const ALERT_BEFORE_TIME = new Date('2021-01-01').getTime();
interface CloneProps {
  id: string | null;
  onHide: () => void;
  onAction: () => void;
  applicationCreatedAt: string;
  hasNonPersonApplicant?: boolean;
  hasGuarantorApplicant?: boolean;
}

function CloneModal(props: CloneProps) {
  const { id, applicationCreatedAt, hasNonPersonApplicant = false, hasGuarantorApplicant = false, ...rest } = props;

  const createdAtTime = new Date(applicationCreatedAt || NOT_ALLOW_BEFORE_TIME).getTime();

  if (hasNonPersonApplicant || hasGuarantorApplicant) {
    return (
      <Modals.Action
        title="The application cannot be copied"
        actionPrimaryButtonLabel="ok"
        isVisible={!!id}
        hideSecondaryButton
        {...rest}
        onAction={props.onHide}
      >
        <Text mt="xs" mb="md">
          The ability to copy applications that include Trust and Company applicants and/or Guarantor applicants is
          currently not supported. To continue, please start a new application.
        </Text>
      </Modals.Action>
    );
  }

  if (createdAtTime <= NOT_ALLOW_BEFORE_TIME) {
    return (
      <Modals.Action
        title="The application cannot be copied"
        actionPrimaryButtonLabel="ok"
        isVisible={!!id}
        hideSecondaryButton
        {...rest}
        onAction={props.onHide}
      >
        <Text mt="xs" mb="md">
          The application you have selected cannot be copied as it was created before May 2020. To continue, you need to
          start a new application.
        </Text>
      </Modals.Action>
    );
  }

  if (NOT_ALLOW_BEFORE_TIME < createdAtTime && createdAtTime <= ALERT_BEFORE_TIME) {
    return (
      <Modals.Action
        title="You're trying to copy an old application"
        actionPrimaryButtonLabel="continue"
        actionSecondaryButtonLabel="cancel"
        isVisible={!!id}
        onSecondaryAction={props.onHide}
        {...rest}
      >
        <Text mt="xs" mb="md">
          Some data might be missing or incorrect as you're trying to copy an old application. Do you want to continue?
        </Text>
      </Modals.Action>
    );
  }

  return (
    <Modals.Action
      title="Copy application"
      actionPrimaryButtonLabel="Copy application"
      isVisible={!!id}
      hideSecondaryButton
      {...rest}
    >
      <Title size="xs">The following will be copied:</Title>
      <Text mt="xs" mb="md">
        Applicants
        <br />
        Employment history
        <br />
        Residential history
        <br />
        Property
        <br />
        E-Consent
        <br />
        Assets &amp; Liabilities
        <br />
        Income
        <br />
        Expenses
        <br />
        ID Verification
      </Text>
      <Title size="xs">The following will not be copied:</Title>
      <Text mt="xs">
        Needs &amp; Objectives
        <br />
        Choose your loan
        <br />
        Required Docs
        <br />
        Required Actions
      </Text>
    </Modals.Action>
  );
}

export default CloneModal;
